
<div *ngIf="loading" class="load-more__container mt-4">
    <div alt="Loading..." class="large progress" >
        <div class="prog1">
            <div class="prog2"></div>
        </div>
    </div>
</div>

<div *ngIf="showGrid && prizePoints.length === 0 && gameType !== '' && gameType === GAMETYPES.EPISODIC" id="prizes" 
    [attr.aria-label]="epHeadlineText" class="prize-grid mt-4">
    <div role="heading" aria-level="2" class="title-lg-bold">
        {{epHeadlineText}}
    </div>
    <div class="body-text mb-4 mt-2">
        {{epSubHeadlineText}}
    </div>
    <ng-container *ngIf="prizes.length > 0">
        <div class="prize-container">
            <ng-container *ngFor="let prize of prizes; let i = index">
                <app-prize-card 
                    [ngClass]="{'prize-card': true, 'card': true, 'episodic__card': gameType === GAMETYPES.EPISODIC}"
                    [gameId]="gameId" [prize]="prize" [availablePoints]="gamePoints.totalGamePoints" [attr.index]="i"
                    [userOptedIn]="userOptedIn" [gameType]="GAMETYPES.EPISODIC" [tokenLabelSingular]="tokenLabelSingular" [tokenLabelPlural]="tokenLabelPlural">
                </app-prize-card>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="prizes.length === 0">
        <ng-template [ngTemplateOutlet]="noprizesmessage"></ng-template>
    </ng-container>
    <app-prize-redeem [programName]="programName" [gameId]="gameId"></app-prize-redeem>
</div>

<div *ngIf="showGrid && resetCount() && gameType !== '' && gameType === GAMETYPES.DIVISION" #prizesContainer id="prizes"
    [attr.aria-label]="'Redeem ' + tokenLabelPlural" class="prize-grid mt-4">
    <ng-container *ngFor="let point of prizePoints">
        <div *ngIf="showContainer()" role="heading" aria-level="2" [id]="'point-group-heading-' + point"
            [attr.data-testid]="'point-group-heading-' + point" [attr.aria-label]="'catalog items requiring ' + groupingLabel(point) + ' to redeem'" class="points-heading title-lg-bold mt-3">
            {{groupingLabel(point)}}
        </div>
        <div *ngIf="showContainer()" class="prize-container">
            <ng-container *ngIf="prizes[point].length > 0">
                <ng-container *ngFor="let prize of prizes[point]; let i = index">
                    <app-prize-card *ngIf="showItem()" [id]="'prize-card' + prize.prizeId"
                        class="prize-card card" [gameId]="gameId" [prize]="prize"
                        [availablePoints]="gamePoints.totalGamePoints" [attr.index]="i" [userOptedIn]="userOptedIn" [userInfo]="userInfo"
                        [gameType]="GAMETYPES.DIVISION" [tokenLabelSingular]="tokenLabelSingular" [tokenLabelPlural]="tokenLabelPlural">
                    </app-prize-card>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>
    <div *ngIf="prizesVisible < numberOfPrizes" class="load-more__container mt-4">
        <button class="btn btn-xl btn-secondary" tabindex="0" role="button" [attr.aria-label]="'Load More'"
            (click)="showMorePrizes()">Load More</button>
    </div>
    <ng-container *ngIf="prizePoints.length === 0">
        <ng-template [ngTemplateOutlet]="noprizesmessage"></ng-template>
    </ng-container>
    <app-prize-redeem [programName]="programName" [gameId]="gameId" [tokenLabelSingular]="tokenLabelSingular" [tokenLabelPlural]="tokenLabelPlural"></app-prize-redeem>

</div>



<ng-template #noprizesmessage>
    <div class="prize-container">
        <div class="empty-list">
            <div>
                <div role="text" aria-label="No Prizes Available" class="message">No Prizes Available
                </div>
            </div>
        </div>
    </div>
</ng-template>